// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"444a8016","617":"32649d2a","640":"6ef580ac"}[chunkId] + ".chunk.js";
};